import { render, staticRenderFns } from "./RenameGroup.vue?vue&type=template&id=5750dcb0"
import script from "./RenameGroup.vue?vue&type=script&lang=js"
export * from "./RenameGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports